/* Dress a HubSpot embed to look like the rest of the store.

   THE THING EVERYONE GETS WRONG HERE, TWICE NOW. HubSpot's v2 embed renders
   the form inside an IFRAME. A stylesheet on our page cannot reach into it and
   CSS custom properties do not cross the boundary either, so every rule you
   write against .hs-input from the theme is ignored and the form lands in
   default HubSpot grey with square corners. The support page had exactly that
   set of dead rules in fx-support.css for a fortnight.

   The iframe is srcdoc, and therefore same origin, so the fix is to append a
   style element to the iframe's own document. Every access is wrapped: if
   HubSpot ever serves it cross origin this has to degrade to an unstyled form
   that still submits, never to a thrown error and an empty box.

   The tokens are written out by value for the same reason. Keep them in step
   with fx-shell.css: 10px radius on fields, the 999px pill on the button, red
   on white, 17px inputs (16px is the iOS floor before a focus zooms the page).

   The same CSS is inlined in snippets/dealer-request-block.liquid. That one
   predates this file; if you touch one, touch both, or fold that snippet onto
   this helper. */
(function () {
  var CSS = [
    'body, .hs-form { font-family: Assistant, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif; color: #1D1D1F; }',
    '.hs-form-field { margin-bottom: 18px; }',
    '.hs-form .hs-form-field > label:not(.hs-error-msg) { display: block; margin: 0 0 6px; font-size: 16px; font-weight: 600; line-height: 1.3; color: #1D1D1F; }',
    '.hs-form .hs-form-field > label:not(.hs-error-msg) > span { font-size: inherit; font-weight: inherit; }',
    '.hs-form .hs-form-field > label .hs-form-required { margin-left: 2px; color: #ED2225; }',
    '.hs-field-desc { margin: 0 0 6px; font-size: 16px; line-height: 1.5; color: #737373; }',
    '.hs-input:not([type="checkbox"]):not([type="radio"]) { width: 100%; box-sizing: border-box; padding: 13px 15px; font-size: 17px; line-height: 1.4; color: #1D1D1F; background: #FFFFFF; border: 1px solid #D4D4D4; border-radius: 10px; box-shadow: none; transition: border-color .15s ease, box-shadow .15s ease; }',
    'textarea.hs-input { min-height: 120px; resize: vertical; }',
    'select.hs-input { height: 50px; }',
    '.hs-input:focus { border-color: #1D1D1F; outline: none; box-shadow: 0 0 0 3px rgba(29,29,31,.16); }',
    '.hs-input.error, .hs-input.invalid { border-color: #ED2225; }',
    '.hs-error-msg, .hs-error-msgs label { color: #ED2225; font-size: 16px; font-weight: 500; }',
    '.hs-form-booleancheckbox label, .hs-form-checkbox label, .hs-form-radio label { font-size: 16px; font-weight: 400; }',
    '.legal-consent-container, .hs-richtext { font-size: 16px; line-height: 1.55; color: #737373; }',
    'h1, h2, h3 { color: #1D1D1F; letter-spacing: -0.015em; }',
    '.hs_submit { margin-top: 22px; }',
    '.hs-button.primary, input[type="submit"].hs-button { display: inline-block; width: 100%; max-width: 280px; min-height: 58px; padding: 15px 30px; font-size: 18px; font-weight: 700; line-height: 1; color: #FFFFFF; background: #ED2225; border: 0; border-radius: 999px; box-shadow: none; cursor: pointer; transition: background .15s ease; }',
    '.hs-button.primary:hover, input[type="submit"].hs-button:hover { background: #F23A3D; }',
    '.submitted-message { font-size: 17px; line-height: 1.6; color: #1D1D1F; }'
  ].join('\n');

  window.fxDressHsFrame = function (mount) {
    try {
      if (!mount) return;
      var frame = mount.querySelector('iframe');
      if (!frame) return;

      // An embed that overflows its column drags the whole page sideways, which
      // is what put the dealer login form off centre.
      frame.style.width = '100%';
      frame.style.maxWidth = '100%';

      var doc = frame.contentDocument;
      if (!doc || !doc.head || doc.getElementById('fxHsDress')) return;
      var st = doc.createElement('style');
      st.id = 'fxHsDress';
      st.textContent = CSS;
      doc.head.appendChild(st);
    } catch (e) {
      /* Cross origin, detached frame, or removed mid measure. An unstyled form
         that submits beats a styled one that never appears. */
    }
  };
})();
